import React from "react";
import { issueNote, primaryAction, rowWindowText, STATUS } from "util/manualDeliveryStatus";
import { dayLabel } from "util/manualDeliveryTime";
import { formatCents } from "util/manualShipment";

// One delivery on the shared fixed grid. A problem gets its own spanning row under it (columns 2 to the end), so
// a long error never changes the row's height or moves a column.
export default function DeliveryRow({
  row,
  first,
  role,
  nowMs,
  todayIso,
  highlighted,
  menuOpen,
  onPrimary,
  onMenu,
  onMenuPress,
}) {
  const status = STATUS[row.display_status] || STATUS.not_sent;
  const primary = primaryAction(row);
  const note = issueNote(row, role, nowMs);
  const name = row.customer_name || "No name";
  const address = row.address_text || "No address";
  let carrierTip = row.reference;
  if (!row.own_driver) {
    carrierTip = row.courier_reference
      ? `${row.courier_reference} · ${row.reference}`
      : `Not booked · ${row.reference}`;
  }
  const classes = ["md-row-wrap"];
  if (first) classes.push("md-row-wrap--first");
  if (highlighted) classes.push("md-row-wrap--new");

  return (
    <div className={classes.join(" ")} data-row-id={row.id}>
      <div role="row" className="md-grid md-row">
        <div role="cell" className="md-cell md-cell--stack">
          <span className="md-strong md-tabular md-ellipsis">{rowWindowText(row)}</span>
          {row.delivery_date ? (
            <span className="md-small md-muted md-ellipsis">{dayLabel(row.delivery_date, todayIso)}</span>
          ) : null}
        </div>
        <div role="cell" className="md-cell md-cell--stack">
          <span className="md-medium md-ellipsis" title={name}>
            {name}
          </span>
          <span className="md-sub md-muted md-ellipsis" title={address}>
            <span className="md-mono md-small">{formatCents(row.total_value_cents)}</span>
            {` · ${address}`}
          </span>
        </div>
        <div role="cell" className="md-cell md-cell--status">
          <span className={`md-pill md-pill--${status.tone}`}>{status.label}</span>
          <span className="md-small md-muted md-ellipsis" title={carrierTip}>
            {row.carrier_name}
          </span>
        </div>
        <div role="cell" className="md-cell md-cell--actions">
          {primary ? (
            <button
              type="button"
              className="md-btn md-btn--row"
              onClick={(event) => onPrimary(row, primary.action, event.currentTarget)}
            >
              {primary.label}
            </button>
          ) : null}
          <button
            type="button"
            className="md-btn md-btn--icon"
            aria-label={`More actions for ${row.customer_name || row.reference}`}
            aria-haspopup="menu"
            aria-expanded={menuOpen ? "true" : "false"}
            onMouseDown={() => onMenuPress(row)}
            onClick={(event) => onMenu(row, event.currentTarget)}
          >
            ⋯
          </button>
        </div>
      </div>
      {note ? (
        <div role="row" className="md-grid md-note-row">
          <div role="cell" aria-colindex={2} aria-colspan={3} className={`md-note md-note--${note.tone}`}>
            <strong>{note.title}</strong>
            <span>{note.text}</span>
          </div>
        </div>
      ) : null}
    </div>
  );
}
